<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">任务失败</div>
      <div class="sub-title" v-text="'红包任务【' + detail.title + '】超时，请重新领取'"></div>
      <div class="btn-middle" @click='hide'>知道了</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto 10px;
    }
  }
</style>
<script>
  import { mapState } from 'vuex'
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    computed: {
      ...mapState({
        detail: state => state.dashboard.taskDetail
      })
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
        $storage.remove('HAS_OPEN_APP_STORE')
        $storage.remove('HAS_OPEN_APP')
        $router.push('/dashboard')
      }
    }
  }
</script>
